module.exports = __webpack_public_path__ + "static/img/CA.811c7617.svg";